"use client"

import { FetchMenusQuery } from "@/apollo/generated/graphql"
import { colors, mediaQueries, sizes } from "@/ui/theme/theme"
import styled from "@emotion/styled"
import { Box, IconButton, ListItem, Typography } from "@mui/material"
import Link from "next/link"
import React, { useState } from "react"
import { extractMenuProperties, getNonUmbracoUrl } from "utils"
import { transformProperties } from "utils/simplifyData"
import { iconsMap } from "../../../public/icons/iconsMap"
import { MegaMenuItems } from "./MegaMenuItems"

const StyledMegaWrepper = styled(Box)`
  position: static;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  gap: 0;
  width: 100%;
  ${mediaQueries.desktopM} {
    gap: ${sizes.baseDouble};
  }
`

const StyledListItem = styled(ListItem)`
  display: flex;
  text-decoration: none;
  cursor: pointer;
  white-space: pre;
  padding: 0;
  gap: ${sizes.baseDouble};
`

const StyledTypo = styled(Typography)`
  white-space: pre;
  font-size: 14px;

  ${mediaQueries.desktopXl} {
    font-size: 18px;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 3px;
  svg {
    transform: rotate(-90deg);
    path {
      stroke: ${colors.red};
    }
    &.phone {
      stroke: ${colors.black};
      fill: ${colors.black};
    }
  }
`
const StyledIconButton = styled(IconButton)`
  display: flex;
  svg {
    display: flex;
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    stroke: ${colors.black};
  }
  ${mediaQueries.mobile} {
    padding: 0;
  }
`

const MegaMenu: React.FC<FetchMenusQuery & any> = ({
  data,
  propertiesToDisplay,
}) => {
  const transformedData = transformProperties(data?.properties)
  const SearchIcon: React.FC = iconsMap["search"]
  const PhoneIcon = iconsMap["phone"]
  const [openSearch, setOpenSearch] = useState(false)
  return (
    <>
      <StyledMegaWrepper>
        {transformedData &&
          transformedData?.megaMenuItemsList?.blocks.map(
            (item: any, index: number) => (
              <MegaMenuItems
                key={`mega-menu-${index}`}
                item={item || ""}
                index={index}
                total={data?.menu_desktop?.children?.length}
              />
            ),
          )}
        <StyledListItem>
          <StyledLink
            href={
              getNonUmbracoUrl(
                extractMenuProperties(propertiesToDisplay[0]).phoneNumber[0]
                  ?.url,
              ) || "/"
            }
          >
            {PhoneIcon && (
              <PhoneIcon width="22" height="22" className="phone" />
            )}
            <StyledTypo>
              {
                extractMenuProperties(propertiesToDisplay[0]).phoneNumber[0]
                  ?.name
              }
            </StyledTypo>
          </StyledLink>
          {/* <StyledIconButton // TODO: uncomment when search is ready and add functionality
            onClick={() => setOpenSearch((prevState) => !prevState)} // not functioning yet
          >
            {SearchIcon && <SearchIcon />}
          </StyledIconButton> */}
        </StyledListItem>
      </StyledMegaWrepper>
    </>
  )
}

export default MegaMenu
